/**
 * @author Matthieu RENAULT <matthieu.renault@ob-do.com>
 */
class uTimestamp {

  static diff(start, stop) {
    return Math.abs(this.unix(stop) - this.unix(start));
  }

  static unix(timestamp) {

    return (timestamp.unix * Math.pow(10, 6) + timestamp.us) / Math.pow(10, 6);
  }
}

export default uTimestamp;
